<template>
  <div>
    <div class="menu-input-group" style="border-bottom: 2px #e8e8e8 solid;">
      <div class="menu-name">{{ button.name }}</div>
      <div class="menu-del" @click="$emit('delMenu')">删除菜单</div>
    </div>
    <div class="menu-input-group">
      <div class="menu-label">菜单名称</div>
      <div class="menu-input">
        <input
          type="text"
          name="name"
          placeholder="请输入菜单名称"
          class="menu-input-text"
          v-model="button.name"
          @input="checkMenuName(button.name)"
        />
        <p class="menu-tips" style="color:#e15f63" v-show="menuNameBounds">
          字数超过上限
        </p>
        <p class="menu-tips">
          字数不超过{{ selectedMenuLevel == 1 ? '5' : '8' }}个汉字
        </p>
      </div>
    </div>
    <div v-show="!button.subButtons || button.subButtons.length == 0">
      <div class="menu-input-group">
        <div class="menu-label">菜单内容</div>
        <div class="menu-input">
          <a-radio-group v-model="button.type">
            <a-radio value="click">自定义点击事件(click)</a-radio>
            <a-radio value="view">跳转网页</a-radio>
            <a-radio value="media_id">发送消息</a-radio>
            <a-radio value="miniprogram">打开指定小程序</a-radio>
            <a-radio value="miniprogramByUser"
              >打开指定小程序(手动配置)</a-radio
            >
          </a-radio-group>
        </div>
      </div>
      <div class="menu-content" v-if="button.type == 'click'">
        <div class="menu-input-group">
          <p class="menu-tips">用于消息接口推送，不超过128字节</p>
          <div class="menu-label">菜单KEY值</div>
          <div class="menu-input">
            <input
              type="text"
              placeholder=""
              class="menu-input-text"
              v-model="button.key"
            />
          </div>
        </div>
      </div>
      <div class="menu-content" v-if="button.type == 'view'">
        <div class="menu-input-group">
          <p class="menu-tips">订阅者点击该子菜单会跳到以下链接</p>
          <div class="menu-label">页面地址</div>
          <div class="menu-input">
            <input
              type="text"
              placeholder=""
              class="menu-input-text"
              v-model="button.url"
            />
          </div>
        </div>
      </div>
      <div class="menu-content" v-else-if="button.type == 'media_id'">
        <div class="menu-input-group">
          <p class="menu-tips">订阅者点击该菜单会收到以下图文消息</p>
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" tab="图文消息">
              <div style="margin: 0 auto;width: 150px">
                <a-button style="margin: 0 auto;" @click="showModalNews()"
                  >选择图文消息</a-button
                >
              </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="图片" force-render>
              <div style="margin: 0 auto;width: 150px">
                <a-button @click="showModalImage()">选择图片</a-button>
              </div>
            </a-tab-pane>
            <!--            <a-tab-pane key="3" tab="文本">-->
            <!--              Content of Tab Pane 3-->
            <!--            </a-tab-pane>-->
          </a-tabs>
        </div>
        <a-modal
          title="选择文章"
          width="700px"
          :visible="visible"
          @cancel="handleCancel"
          @ok="handleOk"
        >
          <a-table
            ref="table"
            size="middle"
            rowKey="mediaId"
            :columns="column"
            :dataSource="articleBatch"
            :rowSelection="{
              type: 'radio',
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange
            }"
            type="radio"
            @change="handleTableChangeNews"
            :pagination="pagination"
          >
          </a-table>
        </a-modal>
        <a-modal
          title="选择图片"
          width="700px"
          :visible="visibleImage"
          @cancel="handleCancel"
          @ok="handleOk"
        >
          <a-table
            ref="table"
            size="middle"
            rowKey="mediaId"
            :columns="columns"
            :dataSource="imageBatch"
            :rowSelection="{
              type: 'radio',
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange
            }"
            type="radio"
            @change="handleTableChangeImage"
            :pagination="pagination"
          >
          </a-table>
        </a-modal>
      </div>
      <div class="menu-content" v-else-if="button.type == 'miniprogram'">
        <div class="menu-input-group">
          <p class="menu-tips">订阅者点击该子菜单会跳到以下小程序</p>
          <div class="menu-label">选择小程序</div>
          <div class="menu-input">
            <a-select
              placeholder="请选择小程序"
              style="width: 200px;padding: 5px 0px 5px 10px;"
              v-model="button.appId"
            >
              <a-select-option
                v-for="(item, index) in wechatMiniApp"
                :key="'info2-' + index"
                :value="item.appId"
                >{{ item.name }}</a-select-option
              >
            </a-select>
          </div>
        </div>
        <div class="menu-input-group">
          <div class="menu-label">小程序路径</div>
          <div class="menu-input">
            <a-select
              placeholder="小程序的页面路径pages/index/index"
              style="width: 200px;padding: 5px 0px 5px 10px;"
              v-model="button.pagePath"
            >
              <a-select-option
                v-for="(item, index) in wechatMiniAppPath"
                :key="'info2-' + index"
                :value="item.value"
                >{{ item.text }}</a-select-option
              >
            </a-select>
          </div>
        </div>
        <div class="menu-input-group">
          <div class="menu-label">备用网页</div>
          <div class="menu-input">
            <input
              type="text"
              placeholder=""
              class="menu-input-text"
              v-model="button.url"
            />
            <p class="menu-tips">
              旧版微信客户端无法支持小程序，用户点击菜单时将会打开备用网页。
            </p>
          </div>
        </div>
      </div>
      <div class="menu-content" v-else-if="button.type == 'miniprogramByUser'">
        <div class="menu-input-group">
          <p class="menu-tips">订阅者点击该子菜单会跳到以下小程序</p>
          <div class="menu-label">小程序appId</div>
          <div class="menu-input">
            <input
              type="text"
              placeholder="小程序的appId（仅认证公众号可配置）"
              class="menu-input-text"
              v-model="button.appId"
            />
          </div>
        </div>
        <div class="menu-input-group">
          <div class="menu-label">小程序路径</div>
          <div class="menu-input">
            <input
              type="text"
              placeholder="小程序的页面路径 pages/index/index"
              class="menu-input-text"
              v-model="button.pagePath"
            />
          </div>
        </div>
        <div class="menu-input-group">
          <div class="menu-label">备用网页</div>
          <div class="menu-input">
            <input
              type="text"
              placeholder=""
              class="menu-input-text"
              v-model="button.url"
            />
            <p class="menu-tips">
              旧版微信客户端无法支持小程序，用户点击菜单时将会打开备用网页。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAction, postAction } from '@/api/manage';
export default {
  props: {
    selectedMenuLevel: {
      type: Number,
      default: 1
    },
    button: {
      type: Object,
      required: true
    },
    wechatAppId: {
      type: String,
      required: true
    },
    pageTotal: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      visibleImage: false,
      menuNameBounds: false, //菜单长度是否过长
      wechatMiniApp: [],
      wechatMiniAppPath: [],
      queryParam: {},
      newsBatch: [],
      articleBatch: [],
      imageBatch: [],
      selectedRowKeys: [],
      mediaIds: '',
      buttons: this.button,
      pagination: {
        total: 0,
        pageSize: 5, //每页中显示10条数据
        showSizeChanger: false,
        pageSizeOptions: ['5', '10', '15', '20'], //每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
      },
      pageQueryParam: {
        page: 1, //第几页
        size: 20 //每页中显示数据的条数
      },
      columns: [
        {
          title: 'mediaId',
          dataIndex: 'mediaId'
        },
        {
          title: '发布时间',
          dataIndex: 'updateTime'
        }
      ],
      column: [
        {
          title: '标题',
          dataIndex: 'title'
        },
        {
          title: '发布时间',
          dataIndex: 'createTime'
        }
      ]
    };
  },
  mounted() {
    this.getWechatMiniApp();
    this.getMiniAppPath();
  },
  methods: {
    showModalNews() {
      this.getNewsBatch();
      this.visible = true;
    },
    showModalImage() {
      this.getFileBatch();
      this.visibleImage = true;
    },
    handleChange(value) {
      this.queryParam.appid = value;
      this.getMenu();
    },
    handleTableChangeNews(pagination) {
      const page = { ...this.pagination };
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.pageQueryParam.page = pagination.current;
      this.pageQueryParam.size = pagination.pageSize;
      this.pagination = page;
    },
    handleTableChangeImage(pagination) {
      const page = { ...this.pagination };
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.pageQueryParam.page = pagination.current;
      this.pageQueryParam.size = pagination.pageSize;
      this.pagination = page;
      this.getFileBatch();
    },
    getMediaIds(wechatAppId, page, time) {
      if (++page < time) {
        this.getMediaIds(this.wechatAppId, page, time);
      }
      getAction(
        process.env.VUE_APP_CMS_WECHAT +
          '/wechat/material/materialNewsBatchGet',
        { appId: wechatAppId, page: page, pageSize: 20 }
      ).then(res => {
        if (res.success) {
          this.newsBatch = res.result.items;
          this.mediaIds = '';
          for (let i in this.newsBatch) {
            this.mediaIds += this.newsBatch[i].mediaId + ',';
          }
          if (this.mediaIds.length > 0) {
            this.mediaIds = this.mediaIds.substr(0, this.mediaIds.length - 1);
          }
          getAction(process.env.VUE_APP_CMS_CONTENT + '/cont/msg/articleInfo', {
            mediaIds: this.mediaIds
          }).then(res => {
            if (res.success) {
              for (let i in res.result) {
                this.articleBatch.push(res.result[i]);
              }
              this.pagination.total = this.articleBatch.length;
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getNewsBatch() {
      let time;
      let page = 0;
      getAction(
        process.env.VUE_APP_CMS_WECHAT + `/wechat/material/materialCount`,
        { appId: this.wechatAppId }
      ).then(res => {
        if (res.success && res.code == 200) {
          time = Math.ceil(res.result.newsCount / 20);
          this.mediaIds = '';
          this.getMediaIds(this.wechatAppId, page, time);
        } else {
          this.$message.error(res.message);
        }
      });
      /*        getAction(process.env.VUE_APP_CMS_WECHAT + '/wechat/material/materialNewsBatchGet', {appId:this.wechatAppId,page:this.pageQueryParam.page,pageSize:this.pageQueryParam.size}).then((res) => {
          if (res.success) {
            this.newsBatch=res.result.items;
            this.mediaIds="";
            for(let i in this.newsBatch){
              this.mediaIds += this.newsBatch[i].mediaId+","
            }
            if (this.mediaIds.length > 0) {
              this.mediaIds = this.mediaIds.substr(0, this.mediaIds.length - 1);
            }
            this.pagination.total=res.result.totalCount;
            getAction(process.env.VUE_APP_CMS_CONTENT + '/cont/msg/articleInfo',{mediaIds:this.mediaIds}).then((res) =>{
              if(res.success){
                this.articleBatch=res.result
              }else{
                this.$message.error(res.message)
              }
            })
          }else{
            this.$message.error(res.message)
          }
        })*/
    },
    getFileBatch() {
      getAction(
        process.env.VUE_APP_CMS_WECHAT +
          '/wechat/material/materialFileBatchGet',
        {
          appId: this.wechatAppId,
          page: this.pageQueryParam.page,
          pageSize: this.pageQueryParam.size
        }
      ).then(res => {
        if (res.success) {
          this.imageBatch = res.result.items;
          this.pagination.total = res.result.totalCount;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getWechatMiniApp() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType', {
        type: 3
      }).then(res => {
        if (res.success) {
          for (let index in res.result) {
            res.result[index].showType = 1;
          }
          this.wechatMiniApp = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getMiniAppPath() {
      getAction(
        process.env.VUE_APP_CMS_SYSTEM + `/sys/dict/getDictItems/miniapp_path`,
        {}
      ).then(res => {
        if (res.success) {
          this.wechatMiniAppPath = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //检查菜单名称长度
    checkMenuName: function(val) {
      if (this.selectedMenuLevel == 1 && this.getMenuNameLen(val) <= 10) {
        this.menuNameBounds = false;
      } else if (
        this.selectedMenuLevel == 2 &&
        this.getMenuNameLen(val) <= 16
      ) {
        this.menuNameBounds = false;
      } else {
        this.menuNameBounds = true;
      }
    },
    //获取菜单名称长度
    getMenuNameLen: function(val) {
      let len = 0;
      for (let i = 0; i < val.length; i++) {
        let a = val.charAt(i);
        a.match(/[^\x00-\xff]/gi) != null ? (len += 2) : (len += 1);
      }
      return len;
    },
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    handleOk(e) {
      this.button.mediaId = this.selectedRowKeys[0];
      this.visible = false;
      this.visibleImage = false;
      this.articleBatch = [];
    },
    handleCancel(e) {
      this.visible = false;
      this.visibleImage = false;
      this.articleBatch = [];
    }
  }
};
</script>
